package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class UpdateAccountRequest(
    val id: String,
    val name: String
)
